import React from 'react'
import { TEXT_KEYS } from '../../constants/textKeys'
import { t } from '../../translation/translation'
import './style.css'

export const TermOfUse = () => {
    return (
        <div className='type-policy-container page-container'>
            <h3>{t(TEXT_KEYS.TERM_OF_USE_TITLE)}</h3>
            <div className='type-policy-container-policy'>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_1)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_1)}</p>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_2)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_2)}</p>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_3)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_3)}</p>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_4)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_4_1)}</p>
                <ul>
                    <li>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_4_2)}</li>
                    <li>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_4_3)}</li>
                </ul>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_5)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_5_1)}</p>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_5_2)}</p>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_6)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_6)}</p>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_7)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_7)}</p>
                <h4>{t(TEXT_KEYS.TERM_OF_USE_TITLE_8)}</h4>
                <p>{t(TEXT_KEYS.TERM_OF_USE_DESCRIPTION_8)}</p>
            </div>

        </div>
    )
}

export default TermOfUse